import React from 'react';
import Remarkable from 'react-remarkable';
import { useDispatch, useSelector } from 'react-redux';
import {
  ModalOverlay,
  ModalContent,
  TitleMarkdown,
  OptionsList,
  OptionItem,
  OptionButton,
  Description,
} from './QuestConfirmationCSS';

const QuestConfirmation = () => {
  const dispatch = useDispatch();
  const currentInteraction = useSelector(
    (state) => state.interaction.currentInteraction
  );

  // Vérifie si l'interaction en cours est de type questConfirmation
  if (!currentInteraction || currentInteraction.type !== 'questConfirmation')
    return null;

  const {
    question,
    questionId,
    description,
    format = 'markdown',
  } = currentInteraction.data;

  const handleOptionClick = (response) => {
    // Envoie la réponse à Redux
    dispatch({
      type: 'INTERACTION_RESPONSE',
      payload: {
        questionId,
        response,
        isAlternative: false,
      },
    });
  };
  // Rendu du titre en fonction du format
  const renderTitle = () => {
    switch (format.toLowerCase()) {
      case 'markdown':
        return (
          <TitleMarkdown>
            <Remarkable source={question ?? ''} />
          </TitleMarkdown>
        );
      case 'html':
        return (
          <TitleHTML dangerouslySetInnerHTML={{ __html: question ?? '' }} />
        );
      case 'text':
      default:
        return <TitleText>{question ?? ''}</TitleText>;
    }
  };

  // Rendu de la description en fonction du format
  const renderDescription = () => {
    if (!description) return null;

    switch (format.toLowerCase()) {
      case 'markdown':
        return (
          <Description>
            <Remarkable source={description ?? ''} />
          </Description>
        );
      case 'html':
        return (
          <DescriptionHTML
            dangerouslySetInnerHTML={{ __html: description ?? '' }}
          />
        );
      case 'text':
      default:
        return <DescriptionText>{description ?? ''}</DescriptionText>;
    }
  };

  return (
    <ModalContent>
      {/* Question en Markdown */}
      {renderTitle()}

      {/* Description avec le format spécifié */}
      {renderDescription()}
      <OptionsList>
        <OptionItem>
          <OptionButton onClick={() => handleOptionClick('Yes')}>
            Yes
          </OptionButton>
        </OptionItem>
        <OptionItem>
          <OptionButton onClick={() => handleOptionClick('No')}>
            No
          </OptionButton>
        </OptionItem>
      </OptionsList>
    </ModalContent>
  );
};

export default QuestConfirmation;
